import React, {useState, useEffect, useContext} from 'react';
import '../../css/callLog.css';
import { gatherCallInfo } from '../../utilities/phoneRelatedFunctions';
import { formatPhoneNumber, formatTimestamp } from '../../utilities/dashFunction';
import {setOpenCalls} from '../../features/topBarSlice';
import { useSelector, useDispatch } from 'react-redux';
import image from '../../assets/icons/loading-loader.gif';
import Icon from '../../assets/icons/icon';
import { fetchWithDefaults } from '../../config/fetchDefault';
import { setMissedCall } from '../../features/missedCallSlice';
import { getSocket } from '../../sockets';
import BrandedButton, { brandedButtonTypes } from '../../utilities/inputComponents/BrandedButton'
import BrandedIconButton from '../../utilities/inputComponents/BrandedIconButton';
import XClose from '../../svgIcon/XClose';

function MissedCalls({openLead}) {
    const dispatch = useDispatch();
    const agentInfo=useSelector((state) => state.agent.userData);
    const missedCallState=useSelector((state) => state.topBar.calls);
    const missedCall=useSelector((state) => state.missedCall.missedCall);
    const [callInfo, setCallInfo] = useState(false);
    const [mode, setMode] = useState('missed');
    const [callsLoading, setCallsLoading] = useState(false);
    const socket = getSocket();

       const clearMissedCalls = async () => {

        if (missedCallState) {
            // Clear missed calls first
            try {
                const res = await fetchWithDefaults(`/callLog/clearMissedCalls?agent=${agentInfo.agentId}`);
                const data = await res.json();

                dispatch(setMissedCall(0));

                socket.off("missedCall"); // clear existing listeners to avoid duplicates
                socket.on("missedCall", (arg) => {
                    dispatch(setMissedCall(arg || 0));
                });

            } catch (err) {
                console.error("Error clearing missed calls:", err);
            }

            // Then gather updated call info
            gatherCallInfo(agentInfo.agentId, mode, setCallInfo, setCallsLoading);
        }
    };

    useEffect( () => {
        const run = async () => {
        if(missedCallState){
            await clearMissedCalls();
            gatherCallInfo(agentInfo.agentId, mode, setCallInfo, setCallsLoading);
        }
        }
        run();
    },[missedCallState,mode])


    const handleClose=()=>{
        dispatch(setOpenCalls(false));
    }

    return (
        <>
            <div className={`leaderBoardWrapper ${missedCallState ? 'openedLeaderBoard': ''}`}>
                {callsLoading && (
                    <div className="smallLoadingWrapper">
                        <div className="innerSmallLoadingWrapper">
                            <img src={image} alt="Loading Gif" style={{width: '100%'}} />
                        </div>
                    </div>
                )}
                <div style={{zIndex: '2', position: 'absolute', width: 48, height: 48, right: 10, top: 5 }}>
                    <BrandedIconButton clickHandler={_ => handleClose()} buttonType={brandedButtonTypes.TERTIARY} >
                        <XClose />
                    </BrandedIconButton>
                </div>
                <div className="leaderBoardHeader">
                    <div className="leaderBoardTitle">Call Log</div>

                </div>
                <div className="convoEntireWrapper">
                    <div className={`conversationLeft`}>
                        <div className="convoListInnerWrapper">
                            <div style={{display: 'flex',justifyContent: 'space-around'}}>

                                    <div style={{width: 140}}>
                                        <BrandedButton
                                            buttonLabel='Missed Calls'
                                            clickHandler={_ => setMode('missed')}
                                        />
                                    </div>

                                    <div style={{width: 140}}>
                                        <BrandedButton
                                            buttonType={brandedButtonTypes.SECONDARY}
                                            buttonLabel='All Calls'
                                            clickHandler={_ => setMode('all')}
                                        />
                                    </div>
                            </div>
                            <div className="callInfoBody">
                                {callInfo && callInfo.map((callItem, index) => (
                                    <div key={`call_item_${index}`} className="callItemWrapper" onClick={()=>openLead(callItem.lead_id)}>
                                        <div className="callLogBlock">
                                            {callItem.borrower_first ? (
                                                <span className="quilityDataLineTitle">{callItem.borrower_first} {callItem.borrower_last}</span>
                                            ) : (
                                                <span className="quilityDataLineTitle">{callItem.call_with}</span>
                                            )}
                                            <div className="subLineWrapper">
                                                {callItem.status==='missed-call' ? (
                                                    <span className={`directionIndication missed`}><span className="fontello"><Icon name={'q-phone-call-missed'} size={18} className="callLogIcon" adjust="fontello" /></span></span>
                                                ) : (
                                                    <span className={`directionIndication ${callItem.direction}`}><span className="fontello"><Icon name={'q-phone-call-outgoing'} size={18} className="outgoingIcon" adjust="fontello" /></span></span>
                                                )}

                                                <span className="callWithItem">{formatPhoneNumber(callItem.number_used)}</span> -
                                                <span className="callWithItem">{formatTimestamp(callItem.date, agentInfo.timezone)}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MissedCalls;
